import { IconWrapper } from '../runtime';
export default IconWrapper('cancel-frequently-used', false, function (h, props) {
  return h("svg", {
    "attrs": {
      "width": props.size,
      "height": props.size,
      "viewBox": "0 0 16 16",
      "fill": "none"
    }
  }, [h("path", {
    "attrs": {
      "d": "M11.9861 7.49739C12.6051 6.42516 13.3032 6.5786 13.7716 6.80545C13.9207 6.87767 14.1021 6.83236 14.1849 6.68887L14.4101 6.29888C14.8243 5.58144 14.5785 4.66401 13.8611 4.2498L9.09794 1.4998C8.3805 1.08558 7.46311 1.3314 7.0489 2.04883L6.8239 2.43855C6.74106 2.58203 6.7923 2.76206 6.9294 2.85509C7.36006 3.14731 7.84199 3.67516 7.22294 4.74739C6.47294 6.04643 6.03992 5.79643 5.35691 5.97944C4.7085 6.15318 2.82896 6.6568 1.7846 8.18931C1.6913 8.32623 1.73835 8.50907 1.88184 8.59191L8.16645 12.2203M6.6039 11.3182L4.60451 14.7827",
      "stroke": props.colors[0],
      "stroke-width": props.strokeWidth,
      "stroke-linecap": props.strokeLinecap,
      "stroke-linejoin": props.strokeLinejoin,
      "vector-effect": "non-scaling-stroke"
    }
  }), h("path", {
    "attrs": {
      "d": "M11.25 10.7498L14.75 14.2498M14.75 10.7498L11.25 14.2498",
      "stroke": props.colors[0],
      "stroke-width": props.strokeWidth,
      "stroke-linecap": props.strokeLinecap,
      "stroke-linejoin": props.strokeLinejoin,
      "vector-effect": "non-scaling-stroke"
    }
  })]);
});